import { render, staticRenderFns } from "./InvoiceFilter.vue?vue&type=template&id=ddd86948"
import script from "./InvoiceFilter.vue?vue&type=script&lang=ts"
export * from "./InvoiceFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports